import { BlockContent } from './BlockContent';

export function BlocksPreview(props) {
  const { previewid, colcount, blockcount, previewitems } = props;
  const isPreviewing = (itemid) => {
    return itemid === previewid ? true : null;
  };

  return (
    <div
      className="sections previewer"
      data-colcount={colcount}
      data-blockcount={blockcount}
    >
      {previewitems.map((item) => (
        <div
          key={item.id}
          data-blockname={item.id}
          className="block-container"
          data-extended={item.extended}
          data-empty={item.empty}
          data-active={isPreviewing(item.id)}
          className="block-container"
        >
          <div className="block">
            <button className="drag-thumb"></button>
            <BlockContent id={item.id} title={item.title} />
          </div>
        </div>
      ))}
    </div>
  );
}
